<template>
  <main class="accountInfo">
    <HeadNav :host="host" />
    <section class="infoContent">
      <AccountInfo :username="userInfo.nickName" :headImg="avator" :identity="[userInfo.identity]" :identityType="userInfo.identityType" />
      <MsgSet :host="host" />
    </section>
    <footer>厦门市虹约产品设计有限公司版权所有 ｜ 闽ICP备15002415号-3</footer>
  </main>
</template>

<script>
import HeadNav from "../../components/header/header.vue";
import AccountInfo from "./components/userInfo.vue";
import MsgSet from "./components/msgSet.vue";
import { mapActions, mapGetters } from "vuex";
import { uploadOSS } from "../../api/accountManage";
export default {
  components: { HeadNav, AccountInfo, MsgSet },
  data() {
    return {
      host: "",
    };
  },
  created() {
    document.title = "爱原物-个人信息";
    this.avatorHost()
    // 获取用户信息
    this.getUserInfo();
  },
  computed: {
    ...mapGetters(["userInfo"]),
    avator() {
      if (this.userInfo.headImg) {
        return this.userInfo.headImg.indexOf("http") > -1
          ? this.userInfo.headImg
          : this.host + this.userInfo.headImg;
      } else {
        return null;
      }
    },
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    // 获取头像显示host
    async avatorHost() {
      const { data } = await uploadOSS().catch(() => { });
      this.host = data.host + "/";
    },
  },
};
</script>

<style lang="scss">
.accountInfo {
  height: 100%;
  background: $grayBgColor;
  display: flex;
  flex-direction: column;
  .infoContent {
    flex: 1;
    flex-direction: column;
    width: 1200px;
    display: flex;
    align-items: flex-start;
    padding-top: 24px;
    margin: auto;
    > div {
      width: 100%;
    }
  }
  footer {
    width: 413px;
    margin: auto;
    text-align: left;
    color: $gray;
    padding: 18px 0;
    font-size: 12px;
  }
}
</style>